import { createFileRoute, Outlet } from "@tanstack/react-router";
import { CropZoneHighlightProvider } from "@/components/field/setup/CropZoneHighlight";

export const Route = createFileRoute(
    "/dashboard/fields/$fieldId/setup/crop-zones",
)({
    component: CropZonesLayout,
});

function CropZonesLayout() {
    return (
        <CropZoneHighlightProvider>
            <Outlet />
        </CropZoneHighlightProvider>
    );
}
